import { Trash2, Sparkles, KeyRound, Brush } from "lucide-react";

const capabilities = [
  { icon: Trash2, title: "Debris Removal" },
  { icon: Sparkles, title: "Property Cleanup" },
  { icon: KeyRound, title: "Turnovers" },
  { icon: Brush, title: "Final Detail Interior Work" },
];

export const Services = () => {
  return (
    <section id="services" className="section-pad bg-charcoal text-warm-white">
      <div className="container-tight">
        <div className="max-w-2xl">
          <span className="eyebrow">Value Position</span>
          <h2 className="mt-4 font-display text-4xl md:text-5xl text-warm-white">
            We Handle the Part Most People <span className="text-brass">Get Wrong.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-warm-white/75 leading-relaxed">
            Most jobs fall apart at the finish.
          </p>
          <p className="mt-3 text-base md:text-lg text-warm-white/75 leading-relaxed">
            We step in where others stop—clearing debris, restoring order, and delivering clean, usable space.
          </p>
        </div>

        <div className="mt-14 grid gap-px bg-warm-white/10 sm:grid-cols-2 lg:grid-cols-4 border border-warm-white/10">
          {capabilities.map(({ icon: Icon, title }) => (
            <div
              key={title}
              className="group relative bg-charcoal p-7 md:p-8 transition-colors duration-500 hover:bg-charcoal-soft"
            >
              <div className="flex h-11 w-11 items-center justify-center border border-brass/50 text-brass transition-all duration-500 group-hover:bg-gradient-brass group-hover:text-charcoal group-hover:border-transparent group-hover:shadow-brass">
                <Icon className="h-5 w-5" strokeWidth={1.4} />
              </div>
              <h3 className="mt-6 font-display text-lg md:text-xl text-warm-white tracking-wide">
                {title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
